// Libs
import { DEFAULT_LANGUAGE, LANGUAGE_LOCAL_STORAGE_KEY } from "src/constants";
import { CalendarLangEnum } from "src/types/enum/CalendarLangEnum";
import { LanguageEnum } from "src/types/enum/LanguageEnum";

const locale =
    (window.localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY) as LanguageEnum) ??
    (navigator.language as LanguageEnum) ??
    DEFAULT_LANGUAGE;

export function getLocale(): LanguageEnum {
    return locale;
}

export function getCalendarLocale(locale: LanguageEnum): CalendarLangEnum {
    const langs: Record<LanguageEnum, CalendarLangEnum> = {
        [LanguageEnum.FR]: CalendarLangEnum.FR,
        [LanguageEnum.GB]: CalendarLangEnum.GB,
        [LanguageEnum.ES]: CalendarLangEnum.ES,
    };

    return langs[locale];
}

export function setLocale(locale: LanguageEnum): void {
    window.localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, locale);
}
